import { useEffect, useRef, useState } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from 'app/components/pages/Extranet/ExtranetInventory/Modern/InventoryStore';

import styles from '../PricingDrawer.module.scss';

import { ExperienceDiscount } from './ExperienceDiscount/ExperienceDiscount';
import { RoomDiscount } from './RoomDiscount/RoomDiscount';
import { RoomPrice } from './RoomPrice/RoomPrice';

type SectionKey = 'roomDiscount' | `pack-${number}`;

type PricingContentProps = {
  isDrawerFullyOpen: boolean;
};

export const PricingContent = ({ isDrawerFullyOpen }: PricingContentProps) => {
  const { packIdForPricingDrawer } = useStore(
    inventoryStore,
    useShallow((state) => ({
      packIdForPricingDrawer: state.packIdForPricingDrawer,
    }))
  );

  const [expandedKey, setExpandedKey] = useState<SectionKey | null>(
    packIdForPricingDrawer ? `pack-${packIdForPricingDrawer}` : null
  );
  const contentRef = useRef<HTMLDivElement>(null);

  const openPricingFromTask = useStore(
    inventoryStore,
    (s) => s.openPricingFromTask
  );

  useEffect(() => {
    if (isDrawerFullyOpen && openPricingFromTask) {
      setExpandedKey('roomDiscount');
    }
  }, [isDrawerFullyOpen, openPricingFromTask]);

  const handleToggle = (key: SectionKey) => {
    setExpandedKey((prev) => (prev === key ? null : key));
  };

  return (
    <div ref={contentRef} className={styles.content}>
      <RoomPrice
        isDrawerFullyOpen={isDrawerFullyOpen}
        containerRef={contentRef}
      />
      <RoomDiscount
        isExpanded={expandedKey === 'roomDiscount'}
        onToggle={() => handleToggle('roomDiscount')}
      />
      <ExperienceDiscount
        expandedPackId={
          expandedKey?.startsWith('pack-')
            ? Number(expandedKey.replace('pack-', ''))
            : null
        }
        onPackToggle={(packId) => handleToggle(`pack-${packId}`)}
      />
    </div>
  );
};
